import { render } from "./TransactionBuilder.vue?vue&type=template&id=22809bd8&scoped=true"
import script from "./TransactionBuilder.vue?vue&type=script&lang=js"
export * from "./TransactionBuilder.vue?vue&type=script&lang=js"

import "./TransactionBuilder.vue?vue&type=style&index=0&id=22809bd8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22809bd8"]])

export default __exports__